import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sparkStudentsList: [],
    totalRecords: 0,
    sparkStudentDetails: {},
    message: null,
    createEditSparkStudentLoading: false,
    createEditSparkStudentSuccess: {},
    createEditSparkStudentError: '',
    hostelList: [],
    totalHostel: 0,
    hostelDetails: {},
    errorMessage: null,
    createEditHostelLoading: false,
    createEditHostelSuccess: {},
    createEditHostelError: '',
    registrationList: [],
    totalRegistration: 0,
    registrationDetails: {},
    registrationErrorMessage: null,
    createEditRegistrationLoading: false,
    createEditRegistrationSuccess: {},
    createEditRegistrationError: '',
}

export const sparkSlice = createSlice({
    name: 'spark',
    initialState,
    reducers: {
        getSparkStudentsList: (state, action) => {
            state.sparkStudentsList = action.payload.data?.data;
            state.totalRecords = action.payload.data?.totalRecord;
            state.message = action.payload.message;
        },
        getSparkStudentDetails: (state, action) => {
            state.sparkStudentDetails = action.payload
        },
        setCreateEditSparkStudentLoading: (state) => {
            state.createEditSparkStudentLoading = true;
            state.createEditSparkStudentSuccess = {};
            state.createEditSparkStudentError = '';
        },
        setCreateEditSparkStudentSuccess: (state, action) => {
            state.createEditSparkStudentLoading = false;
            state.createEditSparkStudentSuccess = action.payload;
            state.createEditSparkStudentError = '';
        },
        setCreateEditSparkStudentError: (state, action) => {
            state.createEditSparkStudentLoading = false;
            state.createEditSparkStudentSuccess = {};
            state.createEditSparkStudentError = action.payload;
        },
        getHostelList: (state, action) => {
            state.hostelList = action.payload.data?.data;
            state.totalHostel = action.payload.data?.totalRecord;
            state.errorMessage = action.payload.message;
        },
        getHostelDetails: (state, action) => {
            state.hostelDetails = action.payload
        },
        setCreateEditHostelLoading: (state) => {
            state.createEditHostelLoading = true;
            state.createEditHostelSuccess = {};
            state.createEditHostelError = '';
        },
        setCreateEditHostelSuccess: (state, action) => {
            state.createEditHostelLoading = false;
            state.createEditHostelSuccess = action.payload;
            state.createEditHostelError = '';
        },
        setCreateEditHostelError: (state, action) => {
            state.createEditHostelLoading = false;
            state.createEditHostelSuccess = {};
            state.createEditHostelError = action.payload;
        },
        getSparkRegistrationList: (state, action) => {
            state.registrationList = action.payload.data?.data;
            state.totalRegistration = action.payload.data?.totalRecord;
            state.registrationErrorMessage = action.payload.message;
        },
        getSparkRegistrationDetails: (state, action) => {
            state.registrationDetails = action.payload
        },
        setCreateEditRegistrationLoading: (state) => {
            state.createEditRegistrationLoading = true;
            state.createEditRegistrationSuccess = {};
            state.createEditRegistrationError = '';
        },
        setCreateEditRegistrationSuccess: (state, action) => {
            state.createEditRegistrationLoading = false;
            state.createEditRegistrationSuccess = action.payload;
            state.createEditRegistrationError = '';
        },
        setCreateEditRegistrationError: (state, action) => {
            state.createEditRegistrationLoading = false;
            state.createEditRegistrationSuccess = {};
            state.createEditRegistrationError = action.payload;
        },
        resetSparkData: (state, action) => {
            state.createEditSparkStudentLoading = false;
            state.createEditSparkStudentSuccess = {};
            state.createEditSparkStudentError = '';
            state.createEditHostelLoading = false;
            state.createEditHostelSuccess = {};
            state.createEditHostelError = '';
            state.createEditRegistrationLoading = false;
            state.createEditRegistrationSuccess = {};
            state.createEditRegistrationError = '';
        },
    },
})

// Action creators are generated for each case reducer function
export const { getSparkStudentsList, getSparkStudentDetails, setCreateEditSparkStudentLoading, setCreateEditSparkStudentSuccess, setCreateEditSparkStudentError, resetSparkData,
    getHostelList, getHostelDetails, setCreateEditHostelLoading, setCreateEditHostelSuccess, setCreateEditHostelError,
    getSparkRegistrationList, getSparkRegistrationDetails, setCreateEditRegistrationLoading, setCreateEditRegistrationSuccess, setCreateEditRegistrationError
} = sparkSlice.actions

export default sparkSlice.reducer;